<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-card class="elevation-6 pa-2">
          <v-card-title class="justify-center">
            <img src="../assets/images/Zapa-Client-Portals-170.png" alt="Zapa Client Portals" style="max-height: 56px;"/>
          </v-card-title>

          <template v-if="!submitted">
            <v-card-subtitle class="text-center pt-2">
              <div class="text-h6 mb-1">Try a live client portal demo</div>
              <div>See exactly what your clients would experience - a demo portal with a sample document is one click away.</div>
            </v-card-subtitle>

            <v-card-text>
              <v-alert v-if="errorBanner" dense text type="warning" class="mb-4">
                {{ errorBanner }}
              </v-alert>

              <v-form ref="demoForm" @submit.prevent="submitRequest">
                <v-text-field
                    v-model="name"
                    label="Your name"
                    outlined
                    dense
                    :rules="[v => !!v && !!v.trim() || 'Please enter your name']"
                ></v-text-field>
                <v-text-field
                    v-model="companyName"
                    label="Company name"
                    outlined
                    dense
                    :rules="[v => !!v && !!v.trim() || 'Please enter your company name']"
                ></v-text-field>
                <v-text-field
                    v-model="email"
                    label="Work email"
                    type="email"
                    outlined
                    dense
                    :rules="[v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || '') || 'Please enter a valid email address']"
                ></v-text-field>
                <!-- Honeypot: hidden from real users, bots tend to fill it. -->
                <input v-model="website" type="text" name="website" tabindex="-1" autocomplete="off" style="position: absolute; left: -9999px;" aria-hidden="true"/>

                <v-btn
                    type="submit"
                    color="primary"
                    block
                    large
                    :loading="submitting"
                    class="mt-2"
                >
                  Get my demo portal
                </v-btn>
              </v-form>
            </v-card-text>
          </template>

          <template v-else>
            <v-card-text class="text-center py-8">
              <v-icon color="success" size="56" class="mb-4">fas fa-envelope-open-text</v-icon>
              <div class="text-h6 mb-2">Check your email</div>
              <div>If everything checks out, we've sent an activation link to <b>{{ email }}</b>. Click it to open your demo portal - the link is valid for 24 hours.</div>
            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as awsVars from '../config/aws-exports';

let awsmobile = awsVars.default(process.env);

export default {
  name: "DemoRequest",
  data() {
    return {
      name: "",
      companyName: "",
      email: "",
      website: "",
      submitting: false,
      submitted: false,
      errorBanner: ""
    };
  },
  mounted() {
    // Friendly messages when the activation endpoint bounces the user back here.
    if (this.$route.query.error === "expired") {
      this.errorBanner = "That activation link has expired. Request a new demo below and we'll email you a fresh link.";
    } else if (this.$route.query.error === "failed") {
      this.errorBanner = "We couldn't activate your demo just now. Please try again, or contact support@zapaportal.com if it keeps happening.";
    }
  },
  methods: {
    submitRequest() {
      let self = this;
      if (!this.$refs.demoForm.validate()) {
        return;
      }
      this.submitting = true;
      this.errorBanner = "";

      const restApiUrl = (awsmobile.aws_rest_api_endpoint || awsmobile.aws_appsync_graphqlEndpoint.replace('/graphql', '')).replace(/\/$/, '');
      fetch(restApiUrl + "/public/trial-demo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: this.name.trim(),
          companyName: this.companyName.trim(),
          email: this.email.trim(),
          website: this.website
        })
      }).then(response => {
        if (response.ok) {
          self.submitted = true;
        } else {
          return response.json().then(body => {
            self.errorBanner = body && body.error ? body.error : "Unable to process your request, please try again.";
          }).catch(() => {
            self.errorBanner = "Unable to process your request, please try again.";
          });
        }
      }).catch(() => {
        self.errorBanner = "Unable to reach the server, please check your connection and try again.";
      }).finally(() => {
        self.submitting = false;
      });
    }
  }
};
</script>

<style scoped>
</style>
